import React from 'react';
import { RouteProps } from 'react-router-dom';
import { dashboardPagesMenu, demoPagesMenu, hrPagesMenu, pageLayoutTypesPagesMenu, pageMenues, productionPagesMenu, purchasingPagesMenu } from '../menu';
import DashboardHeader from '../pages/_layout/_headers/DashboardHeader';
import DepartmentHeader from '../pages/_layout/_headers/DepartmentHeader';
import ProductHeader from '../pages/_layout/_headers/ProductHeader';
import ServiceHeader from '../pages/_layout/_headers/ServiceHeader';
import ProjectHeader from '../pages/_layout/_headers/ProjectHeader';
import SubProjectHeader from '../pages/_layout/_headers/SubProjectHeader';
import PurchaseHeader from '../pages/_layout/_headers/PurchaseHeader';
import HrHiringHeader from '../pages/_layout/_headers/HrHiringHeader';

const headers: RouteProps[] = [
	{ path: pageLayoutTypesPagesMenu.pageLayout.subMenu.onlySubheader.path, element: null },
	{ path: pageLayoutTypesPagesMenu.pageLayout.subMenu.onlyContent.path, element: null },
	{ path: pageLayoutTypesPagesMenu.blank.path, element: null },
	{ path: demoPagesMenu.login.path, element: null },
	{ path: demoPagesMenu.signUp.path, element: null },
	{ path: demoPagesMenu.page404.path, element: null },
	{ path: dashboardPagesMenu.dashboard.path, element: <DashboardHeader /> },
	{ path: `${pageMenues.department.subMenu.general.path}/*`, element: <DepartmentHeader /> },
	{ path: `${pageMenues.product.subMenu.general.path}/*`, element: <ProductHeader /> },
	{ path: `${pageMenues.service.subMenu.general.path}/*`, element: <ServiceHeader /> },
	{ path: `${productionPagesMenu.projects.subMenu.activeProjects.path}/*`, element: <SubProjectHeader /> },
	{ path: `${productionPagesMenu.projects.subMenu.allProjects.path}/*`, element: <ProjectHeader /> },
	{ path: `${hrPagesMenu.hrPositions.subMenu.hrPeriods.path}/*`, element: <HrHiringHeader /> },
	{ path: `${purchasingPagesMenu.purchasingDemands.subMenu.purchasingPeriods.path}/*`, element: <PurchaseHeader /> },
	{
		path: `*`,
		element: <DashboardHeader />,
	},
];

export default headers;
